/* eslint-disable no-console */
<template>
  <div>
    <div class="card z-depth-5 p-3">
      <h4 class="text-center fontweight-bold py-3">My Students</h4>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
            <tr>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">Age Bracket</th>
              <th scope="col">School Grade</th>
              <th scope="col">City</th>
              <th scope="col">Guardian Name</th>
              <th scope="col">Guardian Email</th>
              <th scope="col">Guardian Phone</th>
              <th scope="col">Send Message</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in students" :key="student._id">
              <th>{{ student.first_name }}</th>
              <td>{{ student.last_name }}</td>
              <td>{{ student.age_bracket }}</td>
              <td>{{ student.school_grade }}</td>
              <td>{{ student.city }}</td>
              <td>{{ student.guardian_name }}</td>
              <td>{{ student.guardian_email }}</td>
              <td>{{ student.guardian_phone }}</td>
              <td>
                <button class="btn btn-sm btn-primary" @click="getStudentId(student._id)">
                  Send Message
                </button>
                <mdb-container>
                  <!-- trigger modal button -->

                  <!-- cookie modal -->
                  <mdb-modal :show="modalTeacher" removeBackdrop centered>
                    <mdb-modal-body>
                      <form>
                        <div class="form-group col-md-12">
                          <label>Enter New Message</label>
                          <textarea
                            class="form-control mb-4"
                            v-model="messageToSend"
                          ></textarea>
                        </div>
                        <div class="form-group col-md-12">
                          <!-- Sign in button -->
                          <button
                            class="btn btn-info btn-block my-4"
                            @click.prevent="sendNewMessage()"
                          >
                            Send Message
                          </button>
                        </div>
                      </form>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          data-dismiss="modal"
                          @click="modalTeacher = false"
                        >
                          Close
                        </button>
                      </div>
                    </mdb-modal-body>
                  </mdb-modal>
                </mdb-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mdbContainer, mdbModal, mdbModalBody } from "mdbvue";

export default {
  name: "Students",
  components: {
    mdbContainer,
    mdbModal,
    mdbModalBody,
  },
  data() {
    return {
      modalTeacher: false,
      students: [],
      currentStudentId: "",
      teachers: [],
      teacher: "",
      messageToSend: "",
      fastTeacherToken: localStorage.getItem("fastTeacherToken"),
      fastTeacherId: localStorage.getItem("fastTeacherId"),
    };
  },
  sockets: {
    connect: function () {
      // eslint-disable-next-line no-console
      console.log("socket connected");
    },

    disconnect: function () {
      // eslint-disable-next-line no-console
      console.log("socket disconnected");
    },

    new_message: function (message) {
      // eslint-disable-next-line no-console
      console.log(message.message);
    },

    f_error: function (error) {
      this.$toast.open({
        message: "Error :" + error,
        type: "error",
      });
    },
    error: function (error) {
      this.$toast.open({
        message: "Error :" + error,
        type: "error",
      });
    },
  },
  methods: {
    getStudentId(student) {
      this.currentStudentId = student;
      this.modalTeacher = true;
    },
    sendMessage(receiver, message) {
      // $socket is socket.io-client instance
      this.$socket.emit("new_message", { receiver, message });
    },

    sendNewMessage: function (e) {
      let message = this.messageToSend;
      this.sendMessage(this.currentStudentId, message);
      this.$toast.open({
        message: "<i class='fas fa-check'></i>",
        type: "success",
      });
      this.$router.push("/teacher-messages");
      e.target.reset();
    },
  },
  mounted() {
    this.$toast.open({
      message: "Processing : Loading Students Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastTeacherToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/students?teacher=" + this.fastTeacherId, config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.students = response.data.data.students;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

    axios
      .get(this.$apiURI + "/account/teachers", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.teachers = response.data.data.teachers;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>
